var _effectorFileName = "/src/page-content/cases/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { MainLayout } from '@/widgets/layouts/main';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { CasesBlock } from './components/cases-block';
import { Main } from './components/main';
export const CasesPage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Кейсы" description={`Истории о том, как изучение английского помогло нашим ученикам достичь больших целей. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Кейсы`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description="Истории о том, как изучение английского помогло нашим ученикам достичь больших целей. Энлерно – деловой английский для работы." about={['английский', 'онлайн', 'кейсы']} />

      <Main />

      <CasesBlock />
    </>;
};
CasesPage.Layout = MainLayout;